import { Col, Form, Row } from "reactstrap";
import AddCategoryTag from "./AddCategoryTag";
import PublishStatusDate from "./PublishStatusDate";
import CreateCategory from "./CreateCategory";

// This component handles the categories section, including adding new categories, publishing status, and creating a new category through a modal form.
const Categories = () => {

  return (
    <div className="sidebar-body">
      <Form>
        <Row className="g-lg-4 g-3">
          <Col xs="12">
            <Row className="g-3">
              <AddCategoryTag />
              <CreateCategory />
            </Row>
          </Col>
          <Col xs="12">
            <Row className="g-3">
              <PublishStatusDate />
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Categories;